import WizardStepMixin from '../WizardStepMixin';
import props from './ChooseInstallableMixin.props';
import ChooseProjectDataProvider from '@/components/CreationWizard/Steps/common/ChooseProject/ChooseProjectDataProvider.vue';

/**
 * this mixin is used by headers of all the possible first wizard steps
 */

export default {
	mixins: [WizardStepMixin],
	props,
	computed: {
		_selectedProjectId: {
			get() {
				return this.selectedProjectId;
			},
			set(projectId) {
				this.updateState({ key: 'selectedProjectId', value: projectId });
			},
		},
	},
	components: { ChooseProjectDataProvider },
};
